import type { DueDiligenceStatus } from '@gcv/shared';

/**
 * For convenience, the string value corresponding to each enumerated element is the UI label.
 */
export enum OnboardingStatus {
  Active = 'Active',
  Reviewing = 'Review In Progress',
  Awaiting = 'Awaiting Review',
  Invited = 'Invited',
  Archived = 'Archived'
}

export const DUE_DILIGENCE_TO_ONBOARDING_STATUS: Record<DueDiligenceStatus, OnboardingStatus> = {
  bank_disconnected: OnboardingStatus.Archived,
  bank_approved: OnboardingStatus.Active,
  bank_review_in_progress: OnboardingStatus.Reviewing,
  bank_awaiting_review: OnboardingStatus.Awaiting,
  bank_in_progress: OnboardingStatus.Invited,
  bank_pending: OnboardingStatus.Invited,
  gcv_approved: OnboardingStatus.Invited,
  gcv_awaiting_review: OnboardingStatus.Invited,
  gcv_in_progress: OnboardingStatus.Invited,
  gcv_pending: OnboardingStatus.Invited,
  update_required: OnboardingStatus.Active
};
